/*
 * @Author: lipeihong
 * @Date: 2020-04-13 16:11:02
 * @Last Modified by: lipeihong
 * @Last Modified time: 2020-04-14 14:33:26
 * @【商品详情页】
 */
<template>
  <div class="pg-model-goodsDetail">
    <div v-if="!noData">
      <van-swipe @change="onchange">
        <van-swipe-item
          v-for="(image,index) in images"
          :key="index"
        >
          <van-image
            lazy-load
            class="swipe-item-bg"
            :src="image"
            fit="contain"
            height="7.3rem"
            width="10rem"
          />
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            <span class="current-index">{{ current + 1 }}</span>/{{ images.length }}
          </div>
        </template>
      </van-swipe>
      <div class="detail-top-info">
        <div class="top-top-info">
          <span class="top-info-text2"><span class="text-small">¥</span>{{ groupPrice | formateTotalAmount }}</span>
          <span class="top-info-text3">{{ goodsName }}</span>
        </div>
      </div>
      <div class="detail-middle-info">
        <div class="middle-info-title">
          <span class="icon" />
          <span class="title">规格参数</span>
        </div>
        <div class="middle-info-bottom">
          <div
            v-for="(item,index) in list"
            :key="index"
            class="middle-info-item"
          >
            <span class="info-item-label">{{ item.name }}</span>
            <span class="info-item-value van-ellipsis">{{ item.value }}</span>
            <span
              v-if="copyEnum[item.name]"
              class="info-item-copy"
              @click="handleCopy(item)"
            >
              复制
            </span>
          </div>
        </div>
      </div>
      <div
        class="detail-bottom-info"
        @click="handleBack"
      >
        <span>返回购买</span>
      </div>
    </div>
    <cp-no-data
      v-if="noData"
      title="暂无商品信息"
      :is-show-btn="true"
      :message="errpMessage"
      btn-message="返回活动场"
      @btnClick="handleBack"
    />
  </div>
</template>
<script>
import api from '@/serve'
import Vue from 'vue'
import { Swipe, SwipeItem } from 'vant'
import VueClipboard from 'vue-clipboard2'
import Utils from '@/utils'
// import config from '@/config'
import cpNoData from '@/components/cpNoData'
import mixins from './mixin.js'
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VueClipboard)
export default {
  components: {
    cpNoData
  },
  mixins: [mixins],
  data () {
    return {
      goodsId: null,
      images: [
        'http://tqmall-image.s3.cn-north-1.jcloudcs.com/images/no_picture.gif?t=20180101'
      ],
      copyEnum: {
        '商品编码': 'detail_bianma_fuzhi',
        '规格型号': 'detail_guige_fuzhi'
      },
      current: 0,
      groupPrice: 0,
      oriPrice: 0,
      price: 0,
      goodsNumber: 0,
      goodsName: '',
      noData: false,
      errpMessage: '',
      list: [] // 规格参数列表
    }
  },
  created () {
    // 隐藏APP端右上角X
    Utils.setHideClose()
    if (this.$route.query.goodsId) {
      this.goodsId = this.$route.query.goodsId
      this.groupPrice = this.$route.query.groupPrice || this.$options.data().groupPrice
      this.getGoodsInfo()
    }
  },
  methods: {
    // 发送消息
    postMessageToMiniprogram (shareTitle, shareLogo) {
      Utils.postMessageToMiniprogram({
        shareTitle,
        shareLogo,
        shareUrl: encodeURIComponent(location.href),
        level: 2
      })
    },
    getGoodsInfo () {
      api.getGoodsInfo({
        goodsId: this.goodsId
      }).then(res => {
        if (res.data && res.success && res.data.goodsId) {
          this.list = []
          if (res.data.basicAttrs && res.data.basicAttrs instanceof Array && res.data.basicAttrs.length > 0) {
            this.list = this.list.concat(res.data.basicAttrs)
          }
          if (res.data.extendAttrs && res.data.extendAttrs instanceof Array && res.data.extendAttrs.length > 0) {
            this.list = this.list.concat(res.data.extendAttrs)
          }
          if (res.data.goodsImgs && res.data.goodsImgs instanceof Array && res.data.goodsImgs.length > 0) {
            // this.images = res.data.goodsImgs
            this.images = res.data.goodsImgs.map(url => url.replace(/\/\/|.+\/\//, '//'))
          }
          this.goodsName = res.data.goodsName || ''
          this.oriPrice = parseFloat(res.data.oriPrice) || 0
          this.price = (res.data.goodsActPrice ? parseFloat(res.data.goodsActPrice) : parseFloat(res.data.price)) || 0
          this.goodsNumber = res.data.goodsNumber || 0
          this.noData = false
          // 拿到商品信息后发送消息给小程序
          this.postMessageToMiniprogram(
            this.goodsName,
            this.images[0]
          )
        } else {
          this.noData = true
          this.postMessageToMiniprogram(
            document.title,
            this.images[0]
          )
          this.errpMessage = res.message || ''
          // this.$toast(res.message || '商品信息获取失败~')
        }
      })
    },
    handleCopy (copyItem) {
      this.$copyText(copyItem.value).then(() => {
        this.$toast('复制成功！', 3000)
      }, () => {
        this.$toast('复制失败！', 2000)
      })
      Utils.sendClickData(this.copyEnum[copyItem.name])
    },
    onchange (index) {
      this.current = index
    },
    handleBack () {
      Utils.fromH5Back()
    }
  }
}
</script>
<style lang="stylus">
.pg-model-goodsDetail {
  background-color: #f6f8fc;
  min-height 1500px
  position: relative;
  font-family PingFangSC-Medium;
  .custom-indicator {
    position: absolute;
    right: 39px;
    bottom: 18px;
    font-size: 26px;
    font-family: font-family PingFangSC-Medium;;
    current-index {
      font-weight: bold;
    }
  }
  .swipe-item-bg{
    background-color #fff
  }
  .detail-top-info {
    background-color: #ffffff;
    margin-top: 13px;
    border-radius: 24px;
    padding-left: 30px;
    padding-right: 30px;

    .top-top-info {
      display: flex;
      flex-direction: column;

      .top-info-text2 {
        color: #E1251B;
        font-size: 48px;
        padding-top: 20px;
        padding-bottom: 20px;
        font-family PingFangSC-Medium;
        font-weight: bold;
      }
      .text-small {
        font-family PingFangSC-Medium;
        font-size 36px
      }
      .top-info-text3 {
        font-size: 32px;
        font-weight: medium;
        padding-bottom: 30px;
      }
    }

    .top-up-info {
      height: 86px;
      line-height: 86px;
      font-size: 26px;

      .up-info-text1 {
        color: #999999;
        font-size: 26px;
      }

      .up-info-text2 {
        color: #E1251B;
        font-size: 26px;
        margin-left: 30px;
      }
    }
  }

  .detail-middle-info {
    margin-top: 20px;
    border-radius: 24px;
    background-color: #ffffff;

    .middle-info-title {
      padding: 30px;
      display flex
      align-items center

      .icon{
        margin-right 5px
        display inline-block
        width 6px
        height 32px
        background-color #FF5E41
        border-radius  3px
      }
      .title {
        font-size: 32px;
        font-weight: medium;
      }
    }
    .middle-info-bottom{
      padding 30px
      padding-top 0
      margin-bottom 100px
      .middle-info-item{
        margin-bottom 20px;
        display flex
        font-size 26px
        align-items center
        .info-item-label{
          width 160px
          color :#999999
          text-align right
          font-family PingFangSC-Medium;
        }
        .info-item-value{
          color : #333333
          margin-left 30px
          font-family PingFangSC-Medium;
          flex 1
          width 0
        }
        .info-item-copy{
          color #EF5C4A
        }
      }
    }
  }

  .detail-bottom-info {
    width: 100%;
    height: 100px;
    position: fixed;
    bottom: 0px;
    background: linear-gradient(to right, #FF5E41, #E83624);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 32px;
  }
}
</style>
